var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-box",class:{
    'header-box--small':!_vm.intro,
    'header-box--long':_vm.long,
    'header-box--no-margin':_vm.noMargin
  }},[_c('div',{staticClass:"header-box__innerwrap"},[_c('h1',{staticClass:"header-box__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.intro)?_c('p',{staticClass:"header-box__intro",domProps:{"innerHTML":_vm._s(_vm.intro)}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c88ae5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBox.vue
// module id = null
// module chunks = 